<template>
    <div style="width: 100%; height: 100%; overflow: hidden">
        <div style="width: 100%; height: 100%;" :style="{'transform': startFromBottom ? 'rotate(90deg)' : 'rotate(-90deg)'}">
            <svg viewBox="0 0 545 455" preserveAspectRatio="xMidYMid meet" ref="svg" style="width:100%; height:100%;">
                <circle ref="backgroundCircle" cx="50%" cy="50%" :r="radius" id="red-halo" fill="none" :stroke="backgroundCircleColor" stroke-width="5px" stroke-dasharray="0,20000"  />
                <circle ref="circle" cx="50%" cy="50%" :r="radius" id="green-halo" fill="none" :stroke="circleColor" stroke-width="5px" stroke-dasharray="0,20000"  />
            </svg>
        </div>
        <div style="width: 100%; height: 100%; position: absolute; top:0; left: 0; right: 0; bottom:0; margin:auto; z-index: 5;">
            <svg viewBox="0 0 545 455" preserveAspectRatio="xMidYMid meet" style="width:100%; height:100%;">
                <text class="center-text top-text" x="50%" y="40%" text-anchor="middle" :fill="textColor" v-if="topText">{{topText}}</text>
                <text class="center-text" x="50%" y="52%" text-anchor="middle" :fill="textColor" :style="{'font-size': textSize}">{{text}}</text>
                <text class="center-text bottom-text" x="50%" y="65%" text-anchor="middle" :fill="textColor" v-if="bottomText">{{bottomText}}</text>
                <text class="number" v-for="number in drawableNumbers" v-bind:key="number.number"
                      :x="number.x"
                      :y="number.y"
                      text-anchor="middle"
                      :fill="number.color">{{number.number}}</text>
            </svg>
        </div>
        <div style="width: 100%; height:100%; position: absolute; top:0; left: 0; right: 0; bottom:0;" v-if="useNeedle">
            <svg viewBox="0 0 545 455" preserveAspectRatio="xMidYMid meet" style="width:100%; height:100%;">
                <filter id="blurMe">
                    <feGaussianBlur in="SourceGraphic" stdDeviation="3" />
                </filter>
                <!-- Needle Blurred -->
                <line class="needle"
                      x1="50%"
                      y1="50%"
                      :x2="needlePosition.x2"
                      :y2="needlePosition.y2"
                      filter="url(#blurMe)"
                      :style="{'stroke': NEEDLE_COLOR, 'stroke-width': '3px', 'overflow': 'visible'}"></line>

                <!-- Needle -->
                <line
                    class="needle"
                    x1="50%"
                    y1="50%"
                    :x2="needlePosition.x2"
                    :y2="needlePosition.y2"
                    :style="{'stroke': NEEDLE_COLOR, 'stroke-width': '3px'}"></line>
                <circle cx="50%" cy="50%" :r="5" :stroke="NEEDLE_COLOR" stroke-width="1.5" fill="black" />
            </svg>
        </div>
    </div>
</template>

<script>

    function toRadians (angle) {
        return angle * (Math.PI / 180);
    }

    function progressToAngle(progress) {
        return 360 * progress / 100;
    }

    const DRAW_INTERVAL = 10;
    const DRAW_ANGLE_INCREMENT = 10;
    const DRAW_SPACE_ANGLE = 3;

    const ORIGIN_X = Math.abs(545 / 2);
    const ORIGIN_Y = Math.abs(455 / 2);

    export default {
        name: "chronometer",
        props: {
            text : {
                type: String,
                default: ""
            },
            topText: {
                type: String,
            },
            bottomText: {
                type: String
            },
            textColor: {
                type: String,
                required: true
            },
            textSize: {
                type: String,
                default: "1.8vw !important"
            },
            circleColor: {
                type: String,
                required: true
            },
            backgroundCircleColor: {
                type: String,
                required: true
            },
            progress: {
                type: Number,
                required: true
            },
            startFromBottom: {
                type: Boolean,
                default: false
            },
            numbers: {
                type: Array
            },
            useNeedle: {
                type: Boolean,
                default: false
            },
            instantDraw: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                radius: 10,
                drawTimer: null,
                isDrawing: false,
                drawableNumbers: [],
                needlePosition: {x2:0, y2:0},

                NEEDLE_COLOR: this.circleColor
            }
        },
        methods: {
            draw(drawToAngle) {
                this.isDrawing = true;
                var circle = this.$refs.circle;
                var backgroundCircle = this.$refs.backgroundCircle;

                var angle = 0;
                var finalVersionDrawn = false;
                var backgroundCircleDashArrayPart;
                this.drawTimer = window.setInterval(function () {
                    if (angle <= drawToAngle) {
                        circle.setAttribute("stroke-dasharray", this.getDashArray(angle, 360));
                        backgroundCircle.setAttribute("stroke-dasharray", this.getDashArray(angle, 360));
                        backgroundCircleDashArrayPart = this.getDashArray(0, drawToAngle + DRAW_SPACE_ANGLE);
                    }
                    else {
                        if (!finalVersionDrawn) {
                            circle.setAttribute("stroke-dasharray", this.getDashArray(drawToAngle, 360));
                            finalVersionDrawn = true;
                        }
                        backgroundCircle.setAttribute("stroke-dasharray", backgroundCircleDashArrayPart + "," + this.getDashArray(angle - drawToAngle, 360));
                    }

                    if (angle >= 360) {
                        backgroundCircle.setAttribute("stroke-dasharray", backgroundCircleDashArrayPart + "," + this.getDashArray(360 - drawToAngle - (2 * DRAW_SPACE_ANGLE), DRAW_SPACE_ANGLE));
                        window.clearInterval(this.drawTimer);
                        this.isDrawing = false;
                    }

                    angle += DRAW_ANGLE_INCREMENT;
                }.bind(this), DRAW_INTERVAL);
            },
            update() {
                if (this.isDrawing) return;
                this.setNeedlePosition();
                var drawToAngle;
                if (this.progress == 100)
                    drawToAngle = 360;
                else
                    drawToAngle = progressToAngle(this.progress);

                var circle = this.$refs.circle;
                var backgroundCircle = this.$refs.backgroundCircle;
                backgroundCircle.setAttribute("stroke-dasharray", this.getDashArray(drawToAngle, DRAW_SPACE_ANGLE) + "," + this.getDashArray(360 - drawToAngle - (2 * DRAW_SPACE_ANGLE), DRAW_SPACE_ANGLE));
                circle.setAttribute("stroke-dasharray", this.getDashArray(drawToAngle, 360));
            },
            getDashArray(angle, spaceAngle) {
                var lineLength = toRadians(angle) * this.radius;
                var spaceLength = toRadians(spaceAngle) * this.radius;

                return lineLength + "," + spaceLength;
            },
            getNumberX(angle) {
                var sinMultiplier = angle < 180 ? -1 : 1;
                var sin = Math.abs(Math.sin(toRadians(angle)));
                return ORIGIN_X + (sinMultiplier * (this.radius - 30) * sin);
            },
            getNumberY(angle) {
                var cosMultiplier = (angle < 90 || angle > 270) ? 1 : -1;
                var cos = Math.abs(Math.cos(toRadians(angle)));
                return ORIGIN_Y + (cosMultiplier * (this.radius - 30) * cos);
            },
            drawNumbers() {
                if (!this.numbers) return;

                const ANGLE_BETWEEN_NUMBERS = 360 / (this.numbers.length + 1);

                var drawableNumbers = [];
                for(let i = 0; i < this.numbers.length; i++) {
                    drawableNumbers.push({
                        number: this.numbers[i],
                        x: this.getNumberX(ANGLE_BETWEEN_NUMBERS * (i + 1)),
                        y: this.getNumberY(ANGLE_BETWEEN_NUMBERS * (i + 1)),
                        color: i > 4 ? this.circleColor : "white"
                    })
                }

                this.drawableNumbers = drawableNumbers;
            },
            setNeedlePosition() {
                if (!this.useNeedle) return;

                var angle = progressToAngle(this.progress);

                var sinMultiplier = angle < 180 ? -1 : 1;
                var cosMultiplier = (angle < 90 || angle > 270) ? 1 : -1;

                var sin = Math.abs(Math.sin(toRadians(angle)));
                var cos = Math.abs(Math.cos(toRadians(angle)));

                var x = ORIGIN_X + (sinMultiplier * (this.radius + 1.9) * sin);
                var y = ORIGIN_Y + (cosMultiplier * (this.radius + 1.9) * cos);

                this.needlePosition = {
                    x2: x,
                    y2: y
                }
            },
        },
        mounted() {
            var containerWidth = 545;
            var containerHeight = 455;

            this.radius = Math.floor(Math.min(containerWidth, containerHeight) / 3);

            if (this.instantDraw) {
                this.update()
            } else {
                this.draw(progressToAngle(this.progress));
            }

            this.drawNumbers();
            this.setNeedlePosition();
        },
        beforeDestroy() {
            if (this.drawTimer) {
                clearInterval(this.drawTimer);
            }
        }
    }
</script>

<style scoped>

    .center-text {
        font-size: 1.8vw !important;
        font-family: 'Digital-Serial-Bold';
    }

    .top-text {
        font-size: 1.3vw !important;
        fill: #425467;
    }

    .bottom-text {
        font-size: 1.3vw !important;
        fill: rgb(0,178,188);
    }

    .number {
        font-size: 0.6vw !important;
        font-family: 'Digital-Serial-Bold';
        z-index: 5;
    }

    .needle {
        transition: all 1s;
    }
</style>



// WEBPACK FOOTER //
// src/components/chronometer/Chronometer.vue